<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            color="primary"
            type="gradient"
            class="mb-4 md:mb-0"
            @click="add"
            >Add New Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="keyword"
          @keyup="search"
          placeholder="Search..."
        />
      </div>
      <div class="table-container">
        <el-table
          :data="data"
          :sort-by="sort_by"
          border
          style="width: 100%; margin-top: 10px; margin-bottom: 10px"
        >
          <el-table-column
            label="No"
            width="68"
            type="index"
            :index="indexMethod"
          >
          </el-table-column>
          <el-table-column prop="imei" label="Imei" sortable> </el-table-column>
          <el-table-column prop="device_name" label="Device Name" sortable>
          </el-table-column>
          <el-table-column prop="plate" label="Plate" sortable>
          </el-table-column>
          <el-table-column prop="owner" label="Transfer From" sortable>
          </el-table-column>
          <el-table-column prop="branch_from" label="Branch From" sortable>
          </el-table-column>
          <el-table-column prop="transfer_to" label="Transfer To" sortable>
          </el-table-column>
          <el-table-column prop="branch_to" label="Branch To" sortable>
          </el-table-column>
          <el-table-column prop="date" label="Transfer Date" sortable>
          </el-table-column>
          <el-table-column
            prop="_created_by.username"
            label="Transfer By"
            sortable
          >
          </el-table-column>

          <!-- <el-table-column fixed="right" label="Actions" width="90">
            <template slot-scope="scope">
              <div v-if="scope.row.id !== 0" class="flex">
                <vx-tooltip text="Delete" position="top">
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-trash"
                    color="danger"
                    @click.native.prevent="del(scope.row.id)"
                  ></vs-button>
                  @click.native.prevent="handleClick(scope.$index, scope.row)"
                </vx-tooltip>
              </div>
            </template>
          </el-table-column> -->

          <div
            slot="append"
            v-if="data.length < 1 || loading"
            style="text-align: center; font-size: 13px; padding: 10px"
          >
            {{ loading ? 'Loading....' : 'No Data Available' }}
          </div>
        </el-table>

        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>

      <vs-popup
        classContent="popup-example"
        :title="popupTitle"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-6">
            <div
              :class="
                actor.privilege <= 3
                  ? 'vx-col sm:w-1/1 w-full'
                  : 'vx-col sm:w-1/2 w-full'
              "
            >
              <label class="text-sm opacity-75">Transfer From</label>
              <v-select
                @search="searchUserBy"
                :options="UserByList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="transfer_from"
              />
            </div>

            <!-- <div class="vx-col sm:w-1/2 w-full" v-if="actor.privilege >= 4">
              <label class="text-sm opacity-75">Transfer To Username</label>
              <v-select
                @search="searchUserTo"
                :options="UserToList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="transfer_to"
              />
            </div> -->
          </div>

          <div class="vx-row mb-6" v-if="actor.privilege <= 3">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">Branch of Transfer to</label>
              <v-select
                :options="branchList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="branch_to"
              />
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">Transfer To Username</label>
              <v-select
                @search="searchUserTo"
                :options="UserToList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="transfer_to"
              />
            </div>
          </div>

          <hr />

          <div v-if="action == 'add'" class="vx-card p-6">
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2"
                      >{{ page_gps * per_page_gps - (per_page_gps - 1) }} -
                      {{
                        row_total_gps - page_gps * per_page_gps > 0
                          ? page_gps * per_page_gps
                          : row_total_gps
                      }}
                      of {{ row_total_gps }}</span
                    >
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="updatePerPage_gps(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(25)">
                      <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>

              <div class="vx-col md:w-1/2">
                <vs-input
                  class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                  v-model="keyword_gps"
                  @keyup="search_gps"
                  placeholder="Search..."
                />
              </div>
            </div>

            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Imei</th>
                    <th>Plate</th>
                    <th>Device Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="loading_gps">
                  <tr>
                    <td colspan="6" class="text-center">Loading....</td>
                  </tr>
                </tbody>
                <tbody v-else-if="data_gps.length > 0">
                  <tr v-for="(item, index) in data_gps" :key="index">
                    <td>{{ (page_gps - 1) * per_page_gps + (index + 1) }}</td>
                    <td>{{ item.imei }}</td>
                    <td>{{ item.plate }}</td>
                    <td>{{ item.device_name }}</td>
                    <td style="width: 90px">
                      <div v-if="item.id !== 0" class="flex">
                        <vs-checkbox v-model="list_imei" :vs-value="item.imei">
                        </vs-checkbox>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="text-center">No Data Available</td>
                  </tr>
                </tbody>
              </table>

              <vs-pagination
                :total="n_page_gps"
                v-model="page_gps"
              ></vs-pagination>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit"
                >Submit</vs-button
              >
              <vs-button
                v-show="action === 'add'"
                color="warning"
                type="border"
                @click="reset"
                class="mb-2"
                >Reset</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>
    </div>
  </div>
</template>

<style>
[dir='ltr'] .el-table .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.el-table thead {
  color: #ffff;
  font-weight: bold;
}

[dir] .el-table--border::after,
[dir] .el-table--group::after,
[dir] .el-table::before {
  background-color: #ccc;
}

[dir] .el-table th.el-table__cell {
  background-color: #eee;
  font-size: 14px;
  color: #626262;
}

[dir] .el-table tr:active .el-table__cell {
  background-color: rgb(198, 198, 198);
}

[dir] .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #ffff;
}

[dir] .el-table .descending .sort-caret.descending {
  border-top-color: #ffff;
}

.el-table--border .el-table__cell,
[dir='ltr']
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

[dir] .el-table .el-table__cell {
  padding: 7px 0;
}

.el-table__empty-block {
  display: none !important;
}
</style>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  data() {
    return {
      actor: {},
      data: [],
      data_all: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      loading: true,
      loading_gps: false,

      tempId: 0,
      transfer_from: '',
      branch_to: '',
      transfer_to: '',
      list_imei: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      data_gps: [],
      page_gps: 1,
      per_page_gps: 10,
      row_total_gps: 0,
      keyword_gps: '',

      branchList: [],
      UserToList: [],
      UserByList: [],

      filter: {
        owner: ''
      },

      sort_by:
        ({ prop: 'imei', order: 'descending' },
        { prop: 'device_name', order: 'descending' },
        { prop: 'owner', order: 'descending' },
        { prop: 'branch_from', order: 'descending' },
        { prop: 'transfer_to', order: 'descending' },
        { prop: 'branch_to', order: 'descending' },
        { prop: 'date', order: 'descending' },
        { prop: '_created_by.username', order: 'descending' }),

      timer: null,
      timer_gps: null,
      timer_by: null,
      timer_to: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },
    n_page_gps() {
      return Math.ceil(this.row_total_gps / this.per_page_gps)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    page_gps() {
      this.getVehicle()
    },

    per_page_gps() {
      if (this.page_gps != 1) this.page_gps = 1
      else this.getVehicle()
    },

    transfer_from: {
      handler(val) {
        if (val) {
          this.page_gps = 1
          this.getVehicle()
        } else {
          this.row_total_gps = 0
          this.data_gps = []
        }
      },
      deep: true
    },

    list_imei: {
      handler(val) {
        // console.log(val)
      },
      deep: true
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.initTable()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    search_gps() {
      if (this.timer_gps) {
        clearTimeout(this.timer_gps)
        this.timer_gps = null
      }
      this.timer_gps = setTimeout(() => {
        this.page_gps = 1
        this.getVehicle()
      }, 800)
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    updatePerPage_gps(n) {
      this.per_page_gps = n
      this.getVehicle()
    },

    reset() {
      this.transfer_from = ''
      this.transfer_to = ''
      this.UserByList = []
      this.UserToList = []
      this.list_imei = []
    },

    getVehicle() {
      this.loading_gps = true
      this.$http
        .get(`${this.$api.endpoint}/transfer_unit/data_gps`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            page: this.page_gps,
            per_page: this.per_page_gps,
            search: this.keyword_gps,
            owner: this.transfer_from ? this.transfer_from.value : ''
          }
        })
        .then((res) => {
          this.row_total_gps = res.data.message.total
          this.data_gps = res.data.message.data

          this.loading_gps = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    initTable() {
      this.data = []
      this.loading = true
      this.$http
        .get(
          `${this.$api.endpoint}/transfer_unit/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    getBranchList() {
      this.$http
        .get(`${this.$api.endpoint}/branch/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.branchList = res.data.message.data

          this.branch_to = this.branchList.find((item) => {
            return item.value === this.actor.branch
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    searchUserTo(search) {
      if (search.length >= 3) {
        if (this.timer_to) {
          clearTimeout(this.timer_to)
          this.timer_to = null
        }
        this.timer_to = setTimeout(() => {
          this.$http
            .get(`${this.$api.endpoint}/transfer_unit/transfer_to`, {
              headers: {
                Authorization: `Bearer ${this.token}`
              },
              params: {
                branch:
                  this.actor.privilege >= 4
                    ? this.actor.branch
                    : this.branch_to.value,
                search: search,
                owner: this.transfer_from ? this.transfer_from.value : ''
              }
            })
            .then((res) => {
              this.UserToList = res.data.message.data
            })
            .catch((error) => {
              this.$gf.httpErrorHandler(error)
            })
        }, 800)
      }
    },

    searchUserBy(search) {
      if (search.length >= 3) {
        this.UserToList = []

        if (this.timer_by) {
          clearTimeout(this.timer_by)
          this.timer_by = null
        }
        this.timer_by = setTimeout(() => {
          this.$http
            .get(`${this.$api.endpoint}/user/owner`, {
              headers: {
                Authorization: `Bearer ${this.token}`
              },
              params: {
                branch: this.actor.privilege >= 2 ? this.actor.branch : '',
                search: search
              }
            })
            .then((res) => {
              this.UserByList = res.data.message.data
            })
            .catch((error) => {
              this.$gf.httpErrorHandler(error)
            })
        }, 800)
      }
    },

    add() {
      // if (this.action === 'edit') this.reset()
      this.action = 'add'
      this.popupTitle = 'Add Transfer Unit'

      this.reset()
      this.getBranchList()

      if (this.actor.privilege >= 4) {
        this.transfer_from = {
          label: this.actor.username,
          value: this.actor.id
        }
      }

      this.showPopup = true
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url = `${this.$api.endpoint}/transfer_unit/add`

      this.$http
        .post(
          url,
          {
            imei: this.list_imei,
            transfer_from: this.transfer_from ? this.transfer_from.value : '',
            transfer_to: this.transfer_to ? this.transfer_to.value : '',
            branch_from: this.transfer_from ? this.transfer_from.branch : '',
            branch_to: this.branch_to ? this.branch_to.value : ''
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.notify = res.data.message.split('_').join(' ')
          this.showPopup = false

          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
